import { render } from "./PopupCapTheChoNhanVien.vue?vue&type=template&id=45ee6659"
import script from "./PopupCapTheChoNhanVien.vue?vue&type=script&lang=js"
export * from "./PopupCapTheChoNhanVien.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__